import { createSlice } from "@reduxjs/toolkit";

import { getMappingCountApi, getMappingListApi } from "../../reduxApi/admin/MappingReduxApi";
const getMappingListSlice = createSlice({
  name: "MappingList",
  initialState: {
    getMappingList: [],
    getMappingCount: [],
    status: "idle",
  },
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getMappingListApi.fulfilled, (state, action) => {
      state.status = "fulfilled";
      // console.log("getMappingList action", action.payload);
      state.getMappingList = action.payload.data;
      // console.log("getMappingList", state.getMappingList);
    });
    builder.addCase(getMappingCountApi.fulfilled, (state, action) => {
      state.status = "fulfilled";
      // console.log("getMappingList action", action.payload);
      state.getMappingCount = action.payload.data;
      // console.log("getMappingList", state.getMappingList);
    });
  },
});
// export const { deleteOrdersAction, updateOrdersAction, addOrdersAction } = OrdersSlice.actions
export default getMappingListSlice.reducer;
